<template>
  <footer class="text-gray-700 body-font bg-indigo-500">
    <div
      class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col"
    >
      <a
        href="#"
        class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10 p-2 bg-orange-500"
          viewBox="0 0 24 24"
        >
          <path
            d="M0 0h6v6H0V0zm2 2v2h2V2H2zm12-2h6v6h-6V0zm2 2v2h2V2h-2zm-2 12h6v6h-6v-6zm2 2v2h2v-2h-2zM0 14h6v6H0v-6zm2 2v2h2v-2H2zM6 2h8v2H6V2zm0 14h8v2H6v-2zM16 6h2v8h-2V6zM2 6h2v8H2V6zm5 1h6v2H7V7zm2 2h2v4H9V9z"
          ></path>
        </svg>
        <span class="ml-3 text-xl">Sewa Keith</span>
      </a>
      <p
        class="text-sm text-gray-900 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4"
      >
        © {{ new Date().getFullYear() }}
        <span class="inline-flex">
          Made with
          <svg
            fill="#F00"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="ml-2 w-5 h-5 focus:text-gray-300 hover:text-gray-300"
            viewBox="0 0 512 512"
          >
            <path
              d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
            />
          </svg>
        </span>
      </p>
      <span
        class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start"
      >
        <a
          href="https://twitter.com/skeith696"
          rel="noopener noreferrer"
          target="_blank"
          class="ml-3 text-gray-700 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-150"
        >
          <svg
            fill="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="w-5 h-5 focus:text-gray-300 hover:text-gray-300"
            viewBox="0 0 24 24"
          >
            <path
              d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
            ></path>
          </svg>
        </a>
        <a
          href="https://www.linkedin.com/in/ssewannonda-keith-edwin-443303129"
          target="_blank"
          rel="noopener noreferrer"
          class="ml-3 text-gray-700 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-150"
        >
          <svg
            fill="currentColor"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0"
            class="w-5 h-5 focus:text-gray-300 hover:text-gray-300"
            viewBox="0 0 24 24"
          >
            <path
              stroke="none"
              d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
            ></path>
            <circle cx="4" cy="4" r="2" stroke="none"></circle>
          </svg>
        </a>
        <a href="mailto:skeith696@gmail.com" class="ml-3 text-gray-700">
          <svg
            fill="currentColor"
            class="w-5 h-5 focus:text-gray-300 hover:text-gray-300 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-150"
            viewBox="0 0 512 512"
          >
            <path
              d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
            />
          </svg>
        </a>
      </span>
    </div>
  </footer>
</template>

<script>
// import GenQrCode from "@/components/GenQrCode";

export default {
  name: "SiteFooter",
  //   components: { GenQrCode },
  data: () => ({
    creator: "https://www.linkedin.com/in/ssewannonda-keith-edwin-443303129"
  })
};
</script>
